/* ============================================================
   RK Threads Smart Cart, v2 (calm) - LIVE controller.
   Data-driven from Shopify AJAX cart (/cart.js). Mutations via
   /cart/update.js. Customiser lines that share _rk_group_id are
   folded into ONE row and mutated together. Auto-opens on any
   add-to-cart by observing POST /cart/add(.js). No dependencies.
   ============================================================ */
(function () {
  "use strict";

  var CFG = window.RKC_CONFIG || {};
  var MONEY = CFG.moneyFormat || "${{amount}}";
  var SHIP_AT = parseInt(CFG.shipAt, 10) || 0;      // cents, 0 = disabled
  var CHECKOUT_URL = CFG.checkoutUrl || "/checkout";
  var CROSS = CFG.cross || [];
  var ADDONS = CFG.addons || [];
  var WORKER = (CFG.workerUrl || "").replace(/\/$/, "");
  var SHOP_DOMAIN = CFG.shopDomain || "";
  var CUSTOMER_EMAIL = CFG.customerEmail || "";
  var CURRENCY = "AUD";

  // 2026-07-19: internal plumbing products (the "Customisation" surcharge
  // line, the sold-out "Custom Pre-order" stand-in) must never surface as a
  // quick-add recommendation. They have to STAY published to the Online
  // Store, because /cart/add.js refuses an unpublished variant and the
  // customiser adds the surcharge line on every custom order - so they are
  // filtered here instead. Tag match is the durable rule (any future
  // internal product just needs the tag); handles are a belt-and-braces
  // fallback in case a tag is dropped in the admin.
  var HIDE_REC_TAGS = ["rk-internal", "do-not-list"];
  var HIDE_REC_HANDLES = ["rk-customisation-surcharge", "rk-custom-preorder"];
  function isInternalHandle(h) {
    return !!h && HIDE_REC_HANDLES.indexOf(h) !== -1;
  }
  function isInternalProduct(p) {
    if (!p) return true;
    if (isInternalHandle(p.handle)) return true;
    var tags = p.tags || [];
    for (var i = 0; i < tags.length; i++) {
      if (HIDE_REC_TAGS.indexOf(String(tags[i]).toLowerCase()) !== -1) return true;
    }
    return false;
  }

  // 2026-07-10: user-facing copy in ONE place (wording moved verbatim, not
  // changed). {amt}/{g}/{e} placeholders are swapped at the call site.
  var COPY = {
    shipLabel: "free shipping",
    shipSolo: 'free shipping unlocked, <span class="good">nice.</span>',
    // {gift} is the gift NOUN and comes from RKC_CONFIG.gift.noun, so changing
    // which product is the free gift is a Liquid change only. Do not hardcode
    // the gift product name here again: the gift has changed before and every
    // hardcoded mention had to be hunted down separately.
    giftLabel: "a free {gift}",
    giftWorth: "a free {gift} (worth {amt})",
    giftSolo: 'free {gift} unlocked, <span class="good">nice.</span>',
    bothUnlocked: 'free shipping + a free {gift}, <span class="good">both unlocked.</span>',
    off: "you're <b>{amt}</b> off ",
    recsHead: "you might also like",
    recsHeadShip: "add {amt} more and shipping’s free",
    recsHeadGift: "add {amt} more for the free {gift}",
    rushMix: "heads up: rush production only applies to the item you added it to, so it may be sent separately to the other items in your order. want everything fast? add rush to each custom piece.",
    shipBy: "Made to order - we’ll post it by",
    postBy: "post it by",
    assure: "Made in Melbourne, human-checked before we stitch",
    emptyTitle: 'your bag\'s <span class="accent">hungry</span>',
    emptySub: "nothing in here yet. let's stitch something up.",
    emptyCta: "start customising",
    madeIn: "made in melbourne",
    turnaround: "about 2 weeks",
    checkout: "secure checkout",
    checkoutBusy: "taking you to checkout...",
    editDesign: "edit design",
    priceSplit: "garment {g} + embroidery {e}"
  };

  // 2026-07-10: tiny analytics emitter. dataLayer push always; gtag only if
  // the function actually exists. Never throws - analytics must never break
  // the cart.
  function emit(name, params) {
    try {
      var p = params || {};
      var d = { event: name };
      for (var k in p) { if (p.hasOwnProperty(k)) d[k] = p[k]; }
      (window.dataLayer = window.dataLayer || []).push(d);
      if (typeof window.gtag === "function") window.gtag("event", name, p);
    } catch (e) {}
  }

  // Free gift with purchase. The threshold is ENFORCED at checkout by the
  // matching automatic BXGY discount; here we only drive the drawer UX (auto
  // add/remove + colour picker + shows it as FREE). Which product, which
  // threshold and what it is called all come from RKC_CONFIG.gift, set in
  // snippets/rkc-cart-drawer.liquid. Nothing about the gift is hardcoded here.
  var GIFT = CFG.gift || null;   // { threshold, value, productId, handle, title, noun, blurb, variants:[{colour,variantId,image}] }
  var GIFT_ON = !!(GIFT && GIFT.threshold && GIFT.variants && GIFT.variants.length);
  var GIFT_VIDS = {};
  if (GIFT_ON) GIFT.variants.forEach(function (v) { GIFT_VIDS[String(v.variantId)] = v; });
  var GIFT_NOUN = (GIFT && GIFT.noun) || "gift";
  // Swap {gift} in any COPY string. Call sites still swap {amt} themselves.
  function gcopy(s) { return String(s).replace(/\{gift\}/g, GIFT_NOUN); }

  // Lines the drawer auto-manages: our marker, OR any line of the gift product
  // however it got into the cart.
  //
  // 2026-08-02: this used to be MARKER-ONLY, so that a customer who deep-linked
  // the gift product and bought it "normally" kept a normal priced row instead
  // of a clamped gift card. That reasoning died with the 2026-07-07 fix which
  // repriced every gift variant to $0.00: there is no longer any such thing as
  // buying it normally - the product's own description says "not sold
  // separately" - so a marker-less line was simply a free product anyone could
  // add at any cart value, and reconcile deliberately ignored it. Oscar caught
  // exactly that: free socks sitting in a $196 cart under a $250 offer.
  // Matching on the product id makes reconcile remove it below the threshold
  // and clamp it to one above, no matter how it was added.
  function isGiftLine(it) {
    if (!GIFT_ON || !it) return false;
    if (it.properties && it.properties._rk_free_gift) return true;
    if (GIFT.productId != null && String(it.product_id) === String(GIFT.productId)) return true;
    return false;
  }
  // A marker line whose variant is NOT part of the CURRENT gift product. Cart
  // cookies outlive a gift change by days, so after a flip an old cart still
  // holds a marker-tagged line for the PREVIOUS gift. isGiftLine matches on it
  // alone, so without this the row gets relabelled with the new gift's name and
  // value while still checking out as the old product. reconcileGift drops these.
  function isStaleGiftLine(it) {
    return isGiftLine(it) && !GIFT_VIDS[String(it.variant_id)];
  }
  // Any line of the gift PRODUCT (marker or a manual purchase). The BXGY
  // prerequisite is a collection that EXCLUDES the free-gift-tagged product, so
  // the qualifying spend must exclude every gift line to match checkout exactly.
  function isGiftProductLine(it) {
    if (!GIFT_ON || !it) return false;
    if (it.properties && it.properties._rk_free_gift) return true;
    if (GIFT.productId != null && String(it.product_id) === String(GIFT.productId)) return true;
    return false;
  }
  function giftLineOf(cart) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) if (isGiftLine(items[i])) return items[i];
    return null;
  }
  // ── Father's Day express ($150, ORDER-LEVEL) ────────────────────────────
  // One line for the whole order, not per item (see RKC_CONFIG.fathersDayRush).
  // It carries no _rk_addon_for, so buildRows drops it from the item list on
  // purpose - it would otherwise be billed-but-invisible, which is exactly
  // what the dedicated section below prevents.
  var FDR = CFG.fathersDayRush || null;
  var FDR_KIND = "fathers_day_rush";
  // Offer window closes at the end of FDR.until (store-local date string
  // compare - no timezone maths, the cutoff is a whole day either way).
  // WILLOW ROSTER PAUSE (2026-09-29): no super urgent on FDR.pauseDays,
  // judged on the SHOP's clock (FDR.pauseTz), never the visitor's, so a
  // customer in Perth or London gets the same days as the workshop.
  var FDR_DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  var FDR_DAY_NAMES = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  function fdrShopToday(now) {
    now = now || new Date();
    var tz = (FDR && FDR.pauseTz) || "Australia/Melbourne";
    try {
      var o = {};
      new Intl.DateTimeFormat("en-US", { timeZone: tz, year: "numeric", month: "2-digit", day: "2-digit", weekday: "short" })
        .formatToParts(now).forEach(function (p) { o[p.type] = p.value; });
      var dow = FDR_DAYS.indexOf(o.weekday);
      if (o.year && o.month && o.day && dow >= 0) return { ymd: o.year + "-" + o.month + "-" + o.day, dow: dow };
    } catch (e) {}
    // no Intl time zones (pre-2017 browsers): Melbourne rule by hand. AEDT
    // (+11) runs from 02:00 on the first Sunday of October to 03:00 on the
    // first Sunday of April; both switches fall at 16:00 UTC the Saturday before.
    var y = now.getUTCFullYear();
    function switchAt(month) {
      var first = new Date(Date.UTC(y, month, 1)).getUTCDay();
      var sunday = 1 + ((7 - first) % 7);
      return Date.UTC(y, month, sunday) - 8 * 3600 * 1000;
    }
    var ms = now.getTime();
    var off = (ms >= switchAt(9) || ms < switchAt(3)) ? 11 : 10;
    var d = new Date(ms + off * 3600 * 1000);
    return { ymd: d.toISOString().slice(0, 10), dow: d.getUTCDay() };
  }
  // null = not paused right now; else { today, back } as full day names
  function fdrPause(now) {
    if (!FDR || !FDR.enabled || !FDR.variantId) return null;
    var days = FDR.pauseDays || [];
    if (!days.length) return null;
    var t = fdrShopToday(now);
    if (FDR.pauseFrom && t.ymd < String(FDR.pauseFrom)) return null;
    if (FDR.pauseUntil && t.ymd > String(FDR.pauseUntil)) return null;
    if (days.indexOf(FDR_DAYS[t.dow]) < 0) return null;
    // next day it can be ordered: a day not in pauseDays, or any day after
    // pauseUntil (the last paused day may be followed by a normally-paused one)
    var back = t.dow, p = t.ymd.split("-");
    for (var i = 1; i < 7; i++) {
      back = (t.dow + i) % 7;
      var ymd = new Date(Date.UTC(+p[0], +p[1] - 1, +p[2] + i)).toISOString().slice(0, 10);
      if (days.indexOf(FDR_DAYS[back]) < 0 || (FDR.pauseUntil && ymd > String(FDR.pauseUntil))) break;
    }
    return { today: FDR_DAY_NAMES[t.dow], back: FDR_DAY_NAMES[back] };
  }
  function fdrOffered() {
    if (!FDR || !FDR.enabled || !FDR.variantId) return false;
    if (fdrPause()) return false;
    if (!FDR.until) return true;
    var now = new Date();
    var today = now.getFullYear() + "-" + String(now.getMonth() + 1).padStart(2, "0") + "-" + String(now.getDate()).padStart(2, "0");
    return today <= String(FDR.until);
  }
  function isFdrLine(it) {
    return !!(it && it.properties && it.properties._rk_cart_addon === FDR_KIND);
  }
  function fdrLineOf(cart) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) if (isFdrLine(items[i])) return items[i];
    return null;
  }
  // is there anything to actually rush? (garments, not fees/gift)
  function fdrHasRushableItems(cart) {
    return ((cart && cart.items) || []).some(function (it) {
      return !isFdrLine(it) && !(it.properties && it.properties._rk_cart_addon) && !isGiftProductLine(it);
    });
  }
  // spend that counts toward the gift threshold: everything EXCEPT any gift
  // line (mirrors the BXGY eligible collection, which excludes the gift product).
  // 2026-08-24: the $150 Father's Day express fee is EXCLUDED too - it is a
  // delivery upgrade, not garment spend, so it must not help pay for the
  // gift ($100 of garments + express would otherwise hit $250 and earn the
  // free socks). The checkout Validation Function and the orders/create
  // guard exclude the same line, so all three agree.
  function qualifyingSubtotal(cart) {
    var t = 0;
    ((cart && cart.items) || []).forEach(function (it) {
      if (isGiftProductLine(it) || isFdrLine(it)) return;
      t += (it.final_line_price != null ? it.final_line_price : it.line_price) || 0;
    });
    return t;
  }
  // item count shown to the customer, excluding the free-gift line(s) so the
  // "N items" pill matches the chargeable rows (the gift shows as a bonus).
  function displayCount(cart) {
    if (!cart) return 0;
    if (!GIFT_ON) return cart.item_count || 0;
    var g = 0;
    (cart.items || []).forEach(function (it) { if (isGiftLine(it)) g += it.quantity || 0; });
    return Math.max(0, (cart.item_count || 0) - g);
  }

  // Which products carry the customiser? The embed gates by intersecting a
  // product's tags with the worker's live template tags. Same signal here.
  var LIVE_TAGS = null;
  function liveTemplateTags() {
    if (!LIVE_TAGS) {
      LIVE_TAGS = (WORKER ? fetch(WORKER + "/api/live-template-tags", { credentials: "omit" })
        .then(function (r) { return r.ok ? r.json() : { tags: [] }; })
        .then(function (j) { return new Set(j.tags || []); })
        .catch(function () { return new Set(); }) : Promise.resolve(new Set()));
    }
    return LIVE_TAGS;
  }

  var root = document.getElementById("rkc-cart-root");
  if (!root) return;

  var state = { cart: null, busy: false, suppress: false, giftLock: false };

  /* ---------- helpers ---------- */
  function esc(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }
  function formatMoney(cents) {
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? "," : thousands;
      decimal = decimal == null ? "." : decimal;
      if (isNaN(number) || number == null) return "0";
      number = (number / 100).toFixed(precision);
      var parts = number.split(".");
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var cts = parts[1] ? decimal + parts[1] : "";
      return dollars + cts;
    }
    var re = /\{\{\s*(\w+)\s*\}\}/;
    var m = MONEY.match(re);
    var token = m ? m[1] : "amount";
    var value;
    switch (token) {
      case "amount_no_decimals": value = fmt(cents, 0); break;
      case "amount_with_comma_separator": value = fmt(cents, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": value = fmt(cents, 0, ".", ","); break;
      case "amount_with_space_separator": value = fmt(cents, 2, " ", "."); break;
      default: value = fmt(cents, 2);
    }
    return MONEY.replace(re, value);
  }

  var ICO_X = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 6 L18 18 M18 6 L6 18"/></svg>';
  var ICO_LOCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11 V8 a4 4 0 0 1 8 0 V11"/></svg>';
  var ICO_ARROW = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12 H19 M13 6 L19 12 L13 18"/></svg>';
  var ICO_PLUS = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"><path d="M12 5 V19 M5 12 H19"/></svg>';
  var ICO_ARROW_L = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12 H5 M11 6 L5 12 L11 18"/></svg>';
  var ICO_CHECK = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 L9 17 L4 12"/></svg>';
  var ICO_X_SM = '<svg class="rkc-addon__x" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"><path d="M6 6 L18 18 M18 6 L6 18"/></svg>';
  var ICO_GIFT = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="4"/><path d="M12 8 V21 M5 12 V21 H19 V12 M12 8 C12 8 11 3 8 3 C6 3 6 6 8 6 C10 6 12 8 12 8 Z M12 8 C12 8 13 3 16 3 C18 3 18 6 16 6 C14 6 12 8 12 8 Z"/></svg>';
  var ICO_BOLT = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2 L4 14 H11 L10 22 L20 9 H12 Z"/></svg>';
  // Gift-box glyph, deliberately product-neutral: this marker sits on the
  // progress bar for whatever the current free gift is, so it must not depict
  // a specific product.
  var ICO_GIFT = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M3.5 11.5 H20.5 V20 H3.5 Z"/><path d="M2.5 7.5 H21.5 V11.5 H2.5 Z"/><path d="M12 7.5 V20"/><path d="M12 7.5 C10.5 7.5 8 7.4 8 5.6 a2 2 0 0 1 4 0 a2 2 0 0 1 4 0 c0 1.8 -2.5 1.9 -4 1.9 Z"/></svg>';
  var ICO_TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M2.5 6.5 H14 V15.5 H2.5 Z"/><path d="M14 9.5 H17.5 L20.5 12.5 V15.5 H14 Z"/><circle cx="6.5" cy="17.5" r="1.5"/><circle cx="16.5" cy="17.5" r="1.5"/></svg>';

  function addonMeta(kind) {
    for (var i = 0; i < ADDONS.length; i++) if (ADDONS[i].kind === kind) return ADDONS[i];
    return { kind: kind, label: kind, price: "" };
  }
  function addonIcon(kind) { return kind === "rush" ? ICO_BOLT : ICO_GIFT; }

  // per-item add-ons: show what's on the item + offer the ones it doesn't have
  function addonsHTML(row) {
    if (!ADDONS.length) return "";
    var have = {};
    row.addons.forEach(function (a) { have[a.kind] = 1; });
    // Add-ons the CUSTOMISER already baked into this design line ride as
    // visible "Add-on: <label>" properties (pricing.ts propertiesFor), NOT as
    // separate _rk_cart_addon lines. Treat them as present so we never offer
    // to "add" a gift box / rush that is already on the order (double-charge).
    // They stay in the line's property list and are not independently
    // removable here (they are part of the design), so no "on" chip - we only
    // suppress the matching "add" button.
    var pprops = (row.primary && row.primary.properties) || {};
    var addonKeys = [];
    for (var pk in pprops) { if (pprops.hasOwnProperty(pk) && /^add-?on\s*:/i.test(pk)) addonKeys.push(pk); }
    if (addonKeys.length) {
      ADDONS.forEach(function (a) {
        var lbl = String(a.label || "").toLowerCase();
        var kw = a.kind === "rush" ? "rush" : "gift";
        var hit = addonKeys.some(function (k) {
          var after = k.replace(/^add-?on\s*:\s*/i, "").toLowerCase();
          return after === lbl || (lbl && after.indexOf(lbl) !== -1) || after.indexOf(kw) !== -1;
        });
        if (hit) have[a.kind] = 1;
      });
    }
    var on = row.addons.map(function (a) {
      var m = addonMeta(a.kind);
      return '<button class="rkc-addon rkc-addon--on" data-act="addon-remove" data-key="' + esc(a.key) + '" title="remove ' + esc(m.label) + '">' + ICO_CHECK + '<span class="rkc-addon__l">' + esc(m.label) + '</span><span class="rkc-addon__p">' + formatMoney(a.price) + "</span>" + ICO_X_SM + "</button>";
    });
    var add = ADDONS.filter(function (a) { return !have[a.kind]; }).map(function (a) {
      return '<button class="rkc-addon rkc-addon--add" data-act="addon" data-addon="' + esc(a.kind) + '">' + addonIcon(a.kind) + '<span class="rkc-addon__l">add ' + esc(a.label) + '</span><span class="rkc-addon__p">' + esc(a.price) + "</span></button>";
    });
    // Rush = faster MAKING, not faster postage - customers conflated the two
    // all Father's Day 2026, so the hint sits right under the button.
    var hasRush = row.addons.concat(ADDONS).some(function (a) { return a && a.kind === "rush"; });
    var hint = hasRush ? '<div class="rkc-addons__hint" style="font-size:12px;line-height:1.35;color:#6b7177;margin:4px 0 0;">Rush = made in 5 business days instead of 10. It is not express postage - choose Express Post at checkout if you need faster delivery.</div>' : "";
    return (on.length || add.length) ? '<div class="rkc-addons">' + on.join("") + add.join("") + "</div>" + hint : "";
  }

  /* ---------- cart data ---------- */
  function fetchCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (cart) { state.cart = cart; return cart; });
  }

  // group a cart into display rows. Customiser lines that share a
  // _rk_group_id collapse into a single row; everything else is 1:1.
  function linePrice(it, orig) { var v = orig ? it.original_line_price : it.final_line_price; return (v != null ? v : it.line_price) || 0; }

  function buildRows(cart) {
    var items = cart.items || [];
    // per-item add-on lines (gift box / rush) ride as separate lines linked to
    // their target line via _rk_addon_for; fold them into that item's row.
    var addonLines = [], regular = [], giftShown = false;
    items.forEach(function (item, idx) {
      item._idx = idx;
      if (isGiftLine(item)) {
        // the first marker line renders as the dedicated free-gift row; any
        // surplus (only possible via a race) falls through as a normal, visible,
        // removable row so it is never hidden-yet-billed. reconcile then clamps it.
        if (!giftShown) { giftShown = true; return; }
      }
      if (item.properties && item.properties._rk_cart_addon) addonLines.push(item);
      else regular.push(item);
    });
    var groups = {}, order = [];
    regular.forEach(function (item) {
      var p = item.properties || {};
      var gid = p._rk_group_id || null;
      // Bundle members (e.g. a beanie added alongside the customised garment)
      // share the primary's _rk_group_id for production + the multi-buy
      // discount, but they are DISTINCT products and must render as their own
      // cart line. Without this they fold into (and hide behind) the primary
      // garment's row - the customer sees the combined price but not the item.
      var isBundleMember = !!p._rk_bundle_member_id ||
        (String(p._added_by || "").indexOf("rk-builder-bundle") === 0);
      var kkey = (gid && !isBundleMember) ? ("g:" + gid) : ("l:" + item.key);
      if (!groups[kkey]) { groups[kkey] = { gid: gid, items: [], member: isBundleMember }; order.push(kkey); }
      groups[kkey].items.push(item);
    });
    var rows = order.map(function (kkey) {
      var g = groups[kkey];
      // pick the display anchor: the garment line (carries the design props),
      // not the surcharge line. `_added_by` is stripped from cart lines, so
      // rank by how many visible (non-underscore) properties each line has.
      var primary = g.items[0], best = -1;
      g.items.forEach(function (it) {
        var p = it.properties || {}, c = 0, k;
        for (k in p) { if (p.hasOwnProperty(k) && k.charAt(0) !== "_" && p[k] != null && p[k] !== "") c++; }
        if (c > best) { best = c; primary = it; }
      });
      var finalLine = 0, origLine = 0, surcharge = 0;
      g.items.forEach(function (it) {
        var f = linePrice(it, false);
        finalLine += f; origLine += linePrice(it, true);
        // 2026-07-10: non-anchor fold lines are the embroidery surcharge;
        // captured here (before add-ons fold in) for the price-split caption.
        if (it !== primary) surcharge += f;
      });
      return { custom: !!g.gid, member: !!g.member, keys: g.items.map(function (it) { return it.key; }), primary: primary, qty: primary.quantity, finalLine: finalLine, origLine: origLine, garment: finalLine - surcharge, surcharge: surcharge, addons: [] };
    });
    addonLines.forEach(function (a) {
      var target = a.properties._rk_addon_for, row = null;
      for (var i = 0; i < rows.length; i++) { if (rows[i].keys.indexOf(target) !== -1) { row = rows[i]; break; } }
      if (!row) return;
      row.addons.push({ kind: a.properties._rk_cart_addon, key: a.key, price: linePrice(a, false) });
      row.finalLine += linePrice(a, false);
      row.origLine += linePrice(a, true);
      row.keys.push(a.key);
    });
    return rows;
  }

  // does this value point at an image we can preview?
  function isImageUrl(v) {
    v = String(v);
    if (!/^https?:/i.test(v)) return false;
    if (/\.(jpe?g|png|webp|gif|avif|svg|bmp|tiff)/i.test(v)) return true;
    if (v.indexOf("/uploads/") !== -1) return true;
    if (v.indexOf("cdn.shopify.com/s/files/") !== -1) return true;
    if (/\/api\/file\?/i.test(v)) return true; // rk-custom-builder design-file proxy
    return false;
  }

  // visible line properties, mirroring theme cart-items.liquid rules, but the
  // customer's uploaded design ("Spot N design file") renders as a thumbnail
  // so they can see what they customised.
  function propsHTML(item) {
    var props = item.properties;
    if (!props) return "";
    var lines = [], imgs = [], files = [];
    Object.keys(props).forEach(function (k) {
      var v = props[k];
      if (v == null || v === "") return;
      var sv = String(v);
      if (k.charAt(0) === "_") {
        // 2026-08-27: the builder hides its machine props from checkout with a
        // "_" prefix, which includes the design-file URL. The customer STILL
        // needs to see their uploaded artwork in the drawer - it is the one
        // thing that reassures them the right drawing is on the order - so
        // design-file mirrors surface as thumbnails; everything else stays
        // hidden.
        if (/^_Spot \d+ (design file|extra \d+ file)$/i.test(k) && isImageUrl(sv)) imgs.push(sv);
        return;
      }
      var isFileProp = /^https?:/i.test(sv) && (isImageUrl(sv) || /design file|artwork|upload|photo/i.test(k));
      if (isFileProp) {
        if (isImageUrl(sv)) imgs.push(sv); else files.push({ k: k, url: sv });
        return;
      }
      lines.push('<div><span class="k">' + esc(k) + ':</span> ' + esc(sv) + "</div>");
    });
    var html = "";
    if (lines.length) html += '<div class="rkc-item__props">' + lines.join("") + "</div>";
    if (files.length) html += '<div class="rkc-item__props">' + files.map(function (f) {
      return '<div><span class="k">' + esc(f.k) + ':</span> <a href="' + esc(f.url) + '" target="_blank" rel="noopener">view file</a></div>';
    }).join("") + "</div>";
    if (imgs.length) html += '<div class="rkc-item__design"><span class="rkc-item__design-lbl">your design</span>' + imgs.map(function (u) {
      return '<a href="' + esc(u) + '" target="_blank" rel="noopener" title="your design"><img src="' + esc(u) + '" alt="your design" loading="lazy"></a>';
    }).join("") + "</div>";
    return html;
  }

  function rowHTML(row) {
    var it = row.primary;
    // 2026-07-03: back-order line (a sold-out size, full price since
    // 2026-07-25). The customiser stamps _rk_preorder + a visible
    // "Back-order" prop; badge it.
    var isPreorder = !!(it.properties && it.properties._rk_preorder);
    var tag = isPreorder
      ? '<span class="rkc-tag rkc-tag--pre">back-order</span>'
      : (row.member ? '<span class="rkc-tag rkc-tag--bundle">bundled</span>'
        : (row.custom ? '<span class="rkc-tag">custom</span>' : ""));
    var thumb = it.image
      ? '<div class="rkc-thumb">' + tag + '<img src="' + esc(it.image) + '" alt="" loading="lazy"></div>'
      : '<div class="rkc-thumb">' + tag + "</div>";

    var varLine = "";
    if (it.variant_title && it.variant_title !== "Default Title") varLine = esc(it.variant_title);

    var priceHTML = '<div class="rkc-price" data-key="' + esc(it.key) + '">';
    if (row.origLine !== row.finalLine) {
      priceHTML += "<s>" + formatMoney(row.origLine) + "</s>";
    }
    // keep a bcpo hook so the custom-pricing app can overlay if it wants
    priceHTML += '<span class="bcpo-cart-item-line-price" data-key="' + esc(it.key) + '">' + formatMoney(row.finalLine) + "</span>";
    // name the saving instead of a bare strikethrough (multi-buy etc.)
    if (row.origLine > row.finalLine) {
      priceHTML += '<span class="rkc-item__disc">saved ' + formatMoney(row.origLine - row.finalLine) + "</span>";
    }
    priceHTML += "</div>";

    var stepper = '<div class="rkc-stepper">' +
      '<button data-act="dec" aria-label="decrease">&minus;</button>' +
      '<span>' + row.qty + "</span>" +
      '<button data-act="inc" aria-label="increase">+</button></div>';

    // 2026-07-10: price clarity on folded custom rows - name the garment vs
    // embroidery split. Display only, straight from the folded lines' prices;
    // skipped when the fold carried no surcharge line.
    var split = "";
    if (row.custom && !row.member && row.surcharge > 0) {
      split = '<div class="rkc-item__split">' + COPY.priceSplit.replace("{g}", formatMoney(row.garment)).replace("{e}", formatMoney(row.surcharge)) + "</div>";
    }
    // 2026-07-10: folded custom rows get an "edit design" link - opens the
    // in-cart customiser for this product; its own "Reuse a design in your
    // cart" tile restores the saved design in one tap.
    var links = '<p style="margin:8px 0 0">' +
      (row.custom && !row.member ? '<a href="#" class="rkc-item__var" data-act="edit-design" style="color:var(--plum)">' + COPY.editDesign + '</a><span class="rkc-item__var"> &middot; </span>' : "") +
      '<a href="#" class="rkc-item__var" data-act="remove" style="color:var(--plum)">remove</a></p>';

    return '<div class="rkc-item" data-row="' + esc(row.keys.join("|")) + '" data-primary="' + esc(row.primary.key) + '" data-qty="' + row.qty + '">' +
      thumb +
      '<div style="min-width:0">' +
        '<a class="rkc-item__name" href="' + esc(it.url || "#") + '">' + esc(it.product_title || it.title) + "</a>" +
        split +
        (varLine ? '<div class="rkc-item__var">' + varLine + "</div>" : "") +
        propsHTML(it) +
        links +
      "</div>" +
      '<div class="rkc-item__right">' + priceHTML + stepper + "</div>" +
      addonsHTML(row) +
      "</div>";
  }

  // progress bar with up to two milestones: free shipping then the free gift.
  // Both amounts come from config; do not restate them here.
  // the gift is $0 so it never inflates the spend; both milestones read the same basis.
  function rewardHTML(cart) {
    var v = GIFT_ON ? qualifyingSubtotal(cart) : (cart.total_price || 0);
    var ms = [];
    if (SHIP_AT) ms.push({ at: SHIP_AT, label: COPY.shipLabel, icon: ICO_TRUCK, solo: COPY.shipSolo });
    // copyLabel states the gift's dollar value pre-unlock ("worth $59") so the
    // carrot is a real number, not an implied maybe; label stays short for the
    // milestone marker's title attribute.
    if (GIFT_ON && GIFT.threshold) ms.push({ at: GIFT.threshold, label: gcopy(COPY.giftLabel), copyLabel: GIFT.value ? gcopy(COPY.giftWorth).replace("{amt}", formatMoney(GIFT.value)) : gcopy(COPY.giftLabel), icon: ICO_GIFT, solo: gcopy(COPY.giftSolo) });
    if (!ms.length) return "";
    ms.sort(function (a, b) { return a.at - b.at; });
    var top = ms[ms.length - 1].at;
    var pct = Math.min(100, top ? (v / top * 100) : 0);
    var next = null;
    for (var i = 0; i < ms.length; i++) { if (v < ms[i].at) { next = ms[i]; break; } }
    var allMet = !next;
    var copy = allMet
      ? (ms.length > 1 ? gcopy(COPY.bothUnlocked) : ms[0].solo)
      : COPY.off.replace("{amt}", formatMoney(next.at - v)) + (next.copyLabel || next.label);
    // visible milestone markers ON the bar (truck = free shipping, box = free
    // gift) so the customer can SEE how close each reward is; each lights up green
    // once reached. Positioned by their share of the top goal.
    var nodes = ms.map(function (m) {
      var lp = Math.min(100, top ? (m.at / top * 100) : 0);
      return '<span class="rkc-reward__node' + (v >= m.at ? " is-hit" : "") + '" style="left:' + lp + '%" title="' + esc(m.label) + " at " + formatMoney(m.at) + '">' + m.icon + "</span>";
    }).join("");
    return '<div class="rkc-reward"><div class="rkc-reward__copy">' + copy + "</div>" +
      '<div class="rkc-reward__bar"><div class="rkc-reward__track">' +
        '<div class="rkc-reward__fill' + (allMet ? " is-unlocked" : "") + '" style="width:' + pct + '%"></div>' +
        nodes +
      "</div></div></div>";
  }

  /* ---------- free gift row + colour picker ---------- */
  function giftRowHTML(line) {
    if (!GIFT_ON || !line) return "";
    var cur = GIFT_VIDS[String(line.variant_id)];
    var curColour = cur ? cur.colour : ((line.variant_title && line.variant_title !== "Default Title") ? line.variant_title : "");
    var img = line.image || (cur && cur.image) || (GIFT.variants[0] && GIFT.variants[0].image) || "";
    var thumb = '<div class="rkc-thumb"><span class="rkc-tag rkc-tag--free">free</span>' +
      (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : "") + "</div>";
    var curInList = GIFT.variants.some(function (vr) { return vr.colour === curColour; });
    // if the customer's colour was pulled from the config (sold out / unpublished)
    // while it's in their cart, still show it as the selected chip so the picker
    // isn't left with nothing highlighted.
    var orphanChip = (curColour && !curInList)
      ? '<button class="rkc-opt__chip rkc-gift__chip is-sel" disabled aria-pressed="true" title="currently selected">' + esc(curColour) + "</button>"
      : "";
    var chips = orphanChip + GIFT.variants.map(function (vr) {
      var sel = vr.colour === curColour;
      return '<button class="rkc-opt__chip rkc-gift__chip' + (sel ? " is-sel" : "") +
        '" data-act="gift-colour" data-gift-vid="' + esc(vr.variantId) + '" data-gift-key="' + esc(line.key) +
        '" data-colour="' + esc(vr.colour) + '" aria-pressed="' + (sel ? "true" : "false") + '">' + esc(vr.colour) + "</button>";
    }).join("");
    var price = '<div class="rkc-price">' + (GIFT.value ? "<s>" + formatMoney(GIFT.value) + "</s>" : "") +
      '<span class="rkc-gift__free">free</span></div>';
    return '<div class="rkc-item rkc-item--gift">' +
      thumb +
      '<div style="min-width:0">' +
        '<div class="rkc-gift__badge">free gift unlocked</div>' +
        '<div class="rkc-item__name">' + esc(GIFT.title || "Free gift") + "</div>" +
        (GIFT.blurb ? '<div class="rkc-item__var">' + esc(GIFT.blurb) + "</div>" : "") +
        '<div class="rkc-gift__colours"><span class="rkc-gift__pick" id="rkc-gift-pick-' + esc(line.key) + '">colour</span>' +
        '<div class="rkc-gift__chips" role="group" aria-labelledby="rkc-gift-pick-' + esc(line.key) + '">' + chips + "</div></div>" +
      "</div>" +
      '<div class="rkc-item__right">' + price + "</div>" +
      "</div>";
  }

  // greyed "locked" preview of the gift while the customer sits between the
  // free-shipping and gift thresholds, where a large share of
  // carts land): the reward is SEEN (image + value + gap), not implied by a
  // bar icon. Renders only when no real gift line exists yet.
  function lockedGiftHTML(cart) {
    if (!GIFT_ON || !GIFT.threshold) return "";
    var v = qualifyingSubtotal(cart);
    if (v < (SHIP_AT || 0) || v >= GIFT.threshold) return "";
    var img = (GIFT.variants && GIFT.variants[0] && GIFT.variants[0].image) || "";
    return '<div class="rkc-item rkc-item--gift rkc-item--gift-locked">' +
      '<div class="rkc-thumb">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : "") + "</div>" +
      '<div style="min-width:0">' +
        '<div class="rkc-gift__badge rkc-gift__badge--locked">free at ' + formatMoney(GIFT.threshold) + "</div>" +
        '<div class="rkc-item__name">' + esc(GIFT.title || "Free gift") + "</div>" +
        '<div class="rkc-item__var">' + (GIFT.blurb ? esc(GIFT.blurb) + " &middot; " : "") + "you’re " + formatMoney(GIFT.threshold - v) + " away</div>" +
      "</div>" +
      '<div class="rkc-item__right"><div class="rkc-price">' + (GIFT.value ? "<s>" + formatMoney(GIFT.value) + "</s>" : "") + "</div></div>" +
      "</div>";
  }

  /* ---------- recommendations (recently-viewed + related), async ---------- */
  var recCache = { key: null, html: null };
  var lastRecsHtml = "";  // keep the last recommendations visible while reloading
  function cartSig(cart) { return (cart.items || []).map(function (i) { return i.handle; }).sort().join(","); }

  // record product-page views for the "recently viewed" recommendations
  function recordRecentlyViewed() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    if (isInternalHandle(m[1])) return; // never seed recs with plumbing products
    try {
      var list = JSON.parse(localStorage.getItem("rkc_rv") || "[]");
      // Also scrub any internal handle a shopper already has cached from
      // before this filter existed.
      list = list.filter(function (h) { return h !== m[1] && !isInternalHandle(h); });
      list.unshift(m[1]);
      localStorage.setItem("rkc_rv", JSON.stringify(list.slice(0, 12)));
    } catch (e) {}
  }

  // normalise a Shopify product (/products/x.js OR recommendations product) to a rec
  function toRec(p) {
    var tags = p.tags || [];
    var img = p.featured_image;
    if (img && typeof img === "object") img = img.src || img.url || "";
    if (!img && p.images && p.images.length) img = (typeof p.images[0] === "string") ? p.images[0] : (p.images[0].src || "");
    var optionNames = (p.options || []).map(function (o) { return (typeof o === "string") ? o : ((o && o.name) || ""); });
    var nd = optionNames.length || 1;
    var variants = (p.variants || []).map(function (v) { return { id: v.id, title: v.title, available: v.available !== false, price: v.price, opts: [v.option1, v.option2, v.option3].slice(0, nd) }; });
    var price = (p.price_min != null) ? p.price_min : (p.price != null ? p.price : ((variants[0] && variants[0].price) || 0));
    return { handle: p.handle, productId: p.id, title: p.title, url: p.url || ("/products/" + p.handle), image: img || "", price: price, tags: tags, hasCustomiser: false, optionNames: optionNames, variants: variants };
  }

  var currentRecs = [];   // recs currently rendered (indexed)
  var recSel = {};        // idx -> { dim: value }

  function recThumb(url) {
    return url ? '<div class="rkc-rec__thumb"><img src="' + esc(url) + '" alt="" loading="lazy"></div>' : '<div class="rkc-rec__thumb"></div>';
  }
  function optionValues(rec, dim) {
    var out = [], seen = {};
    rec.variants.forEach(function (v) {
      var val = v.opts[dim];
      if (val == null || seen[val]) return;
      seen[val] = 1;
      out.push({ value: val, orderable: rec.variants.some(function (v2) { return v2.opts[dim] === val && v2.available; }) });
    });
    return out;
  }
  function optsPickerHTML(rec, idx, mode) {
    var dims = rec.optionNames.length || 1, groups = "";
    for (var d = 0; d < dims; d++) {
      var chips = optionValues(rec, d).map(function (o) {
        return '<button class="rkc-opt__chip' + (o.orderable ? "" : " is-off") + '" data-rec-opt="' + idx + '" data-dim="' + d + '" data-val="' + esc(o.value) + '"' + (o.orderable ? "" : " disabled") + ">" + esc(o.value) + "</button>";
      }).join("");
      groups += '<div class="rkc-opt"><span class="rkc-opt__label">' + esc(rec.optionNames[d] || "Option") + '</span><div class="rkc-opt__chips">' + chips + "</div></div>";
    }
    var label = mode === "customise" ? "customise" : "add to cart";
    // 2026-07-10: stamp the product identity ON the button. The click
    // handlers used to depend only on currentRecs[idx], which every cart
    // re-render / recommendation reload resets - a tap in that window
    // silently did nothing ("customise doesn't open the editor"). With
    // the identity on the node, the handler can always rebuild what it
    // needs (or at worst fall back to the PDP), never a silent no-op.
    return '<div class="rkc-rec__opts" data-rec-opts="' + idx + '">' + groups +
      '<button class="rkc-rec__confirm" data-rec-confirm="' + idx + '" data-mode="' + mode + '"' +
      ' data-handle="' + esc(rec.handle) + '" data-pid="' + esc(rec.productId) + '" data-url="' + esc(rec.url) + '" data-title="' + esc(rec.title) + '" disabled>' + label + "</button></div>";
  }

  function recRowHTML(rec, idx) {
    var priceLabel = (rec.variants.length > 1 ? "from " : "") + formatMoney(rec.price);
    var main = '<a class="rkc-rec__main" href="' + esc(rec.url) + '">' + recThumb(rec.image) +
      '<div class="rkc-rec__info"><div class="rkc-rec__name">' + esc(rec.title) + '</div><div class="rkc-rec__price">' + esc(priceLabel) + "</div></div></a>";
    var avail = rec.variants.filter(function (v) { return v.available; });
    var single = avail.length <= 1;
    var vid = (avail[0] || rec.variants[0] || {}).id;
    var action, opts = "";
    if (rec.hasCustomiser) {
      // customiser product -> open the real customiser inside the cart
      if (single) {
        action = '<button class="rkc-rec__btn rkc-rec__btn--ghost" data-rec-cz="' + idx + '" data-vid="' + esc(vid) + '" data-handle="' + esc(rec.handle) + '" data-pid="' + esc(rec.productId) + '" data-url="' + esc(rec.url) + '" data-title="' + esc(rec.title) + '">customise ' + ICO_ARROW + "</button>";
      } else {
        action = '<button class="rkc-rec__btn rkc-rec__btn--ghost" data-rec-expand="' + idx + '">customise ' + ICO_ARROW + "</button>";
        opts = optsPickerHTML(rec, idx, "customise");
      }
    } else {
      // plain product -> add straight to cart (one-click or size/colour picker)
      if (single) {
        action = '<button class="rkc-rec__btn" data-rec-add="' + esc(vid) + '">add ' + ICO_PLUS + "</button>";
      } else {
        action = '<button class="rkc-rec__btn" data-rec-expand="' + idx + '">add ' + ICO_PLUS + "</button>";
        opts = optsPickerHTML(rec, idx, "add");
      }
    }
    return '<div class="rkc-rec" data-rec-idx="' + idx + '"><div class="rkc-rec__top">' + main + '<div class="rkc-rec__action">' + action + "</div></div>" + opts + "</div>";
  }

  function recsBlock(rowsHTML) {
    // Milestone-aware header: when the cart sits under a reward threshold,
    // sell the recs as the key that unlocks it instead of a generic
    // "you might also like" (the curated accessories are priced exactly
    // in gap range: cap $59, beanie $59).
    var head = COPY.recsHead;
    try {
      var cart = state.cart;
      if (cart) {
        var v = GIFT_ON ? qualifyingSubtotal(cart) : (cart.total_price || 0);
        if (SHIP_AT && v > 0 && v < SHIP_AT) {
          head = COPY.recsHeadShip.replace("{amt}", formatMoney(SHIP_AT - v));
        } else if (GIFT_ON && GIFT.threshold && v >= (SHIP_AT || 0) && v < GIFT.threshold) {
          head = gcopy(COPY.recsHeadGift).replace("{amt}", formatMoney(GIFT.threshold - v));
        }
      }
    } catch (e) {}
    return '<div class="rkc-cross"><div class="rkc-cross__head">' + head + '</div><div class="rkc-cross__list">' + rowsHTML + "</div></div>";
  }
  function renderRecs(recs) {
    currentRecs = recs; recSel = {};
    return recsBlock(recs.map(recRowHTML).join(""));
  }
  function curatedHTML() {
    if (!(CROSS && CROSS.length)) return "";
    currentRecs = []; recSel = {};
    var rows = CROSS.map(function (p) {
      return '<div class="rkc-rec"><div class="rkc-rec__top"><a class="rkc-rec__main" href="' + esc(p.url) + '">' + recThumb(p.image) +
        '<div class="rkc-rec__info"><div class="rkc-rec__name">' + esc(p.title) + '</div><div class="rkc-rec__price">' + esc(p.price) + "</div></div></a>" +
        '<div class="rkc-rec__action"><a class="rkc-rec__btn rkc-rec__btn--ghost" href="' + esc(p.url) + '">customise ' + ICO_ARROW + "</a></div></div></div>";
    }).join("");
    return recsBlock(rows);
  }
  function fetchProduct(handle) {
    return fetch("/products/" + encodeURIComponent(handle) + ".js", { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }

  async function loadRecommendations(cart) {
    var slot = root.querySelector("#rkc-cross-slot");
    if (!slot) return;
    var sig = cartSig(cart);
    if (recCache.key === sig && recCache.html != null) { currentRecs = recCache.recs || []; recSel = {}; slot.innerHTML = recCache.html; bindRecs(); return; }
    var inCart = {}; (cart.items || []).forEach(function (i) { inCart[i.handle] = 1; });
    var handles = [], seen = {}, TARGET = 3;
    function addHandle(h) { if (h && !inCart[h] && !seen[h] && !isInternalHandle(h)) { seen[h] = 1; handles.push(h); } }
    // 1) recently viewed
    var rv = [];
    try { rv = JSON.parse(localStorage.getItem("rkc_rv") || "[]"); } catch (e) {}
    rv.forEach(addHandle);
    // 2) related to the first cart item, to fill remaining slots
    if (handles.length < TARGET && cart.items && cart.items.length) {
      try {
        var rel = await fetch("/recommendations/products.json?product_id=" + cart.items[0].product_id + "&intent=related&limit=12", { headers: { Accept: "application/json" }, credentials: "same-origin" }).then(function (r) { return r.json(); });
        (rel.products || []).forEach(function (p) { addHandle(p.handle); });
      } catch (e) {}
    }
    handles = handles.slice(0, TARGET);
    // fetch full product data (options for the picker) + the live-template tag
    // set (to tell customiser products from plain add-to-cart products)
    var liveSet = await liveTemplateTags();
    var recs = [];
    for (var i = 0; i < handles.length; i++) {
      var p = await fetchProduct(handles[i]);
      // Tag check needs the FULL product (the handle list can't see tags),
      // so internal products are dropped here as well as in addHandle.
      if (p && p.handle && !isInternalProduct(p)) {
        var rec = toRec(p);
        rec.hasCustomiser = rec.tags.some(function (t) { return liveSet.has(t); });
        recs.push(rec);
      }
    }
    var html = recs.length ? renderRecs(recs) : curatedHTML();
    recCache = { key: sig, html: html, recs: recs };
    lastRecsHtml = html;
    slot.innerHTML = html; bindRecs();
  }

  function resolveVariant(rec, sel) {
    if (!rec) return null;
    var dims = rec.optionNames.length || 1;
    for (var i = 0; i < rec.variants.length; i++) {
      var v = rec.variants[i], ok = true;
      for (var d = 0; d < dims; d++) { if (sel[d] == null || v.opts[d] !== sel[d]) { ok = false; break; } }
      if (ok) return v;
    }
    return null;
  }
  function updateConfirm(idx) {
    var btn = root.querySelector('[data-rec-confirm="' + idx + '"]');
    if (!btn) return;
    var v = resolveVariant(currentRecs[+idx], recSel[idx] || {});
    btn.disabled = !(v && v.available);
    var label = btn.getAttribute("data-mode") === "customise" ? "customise" : "add to cart";
    btn.textContent = (v && !v.available) ? "sold out" : label;
  }
  function bindRecs() {
    // single-variant / curated one-click add
    root.querySelectorAll("[data-rec-add]").forEach(function (el) {
      el.onclick = function (e) {
        e.preventDefault(); e.stopPropagation();
        // 2026-07-10: analytics (handle from the rec card when still indexed)
        var card = el.closest("[data-rec-idx]");
        var r = card ? currentRecs[+card.getAttribute("data-rec-idx")] : null;
        emit("rkc_rec_clicked", { handle: (r && r.handle) || "", mode: "add" });
        quickAdd(el.getAttribute("data-rec-add"), el);
      };
    });
    // reveal the Size/Colour picker
    root.querySelectorAll("[data-rec-expand]").forEach(function (el) {
      el.onclick = function (e) {
        e.preventDefault(); e.stopPropagation();
        var opts = root.querySelector('[data-rec-opts="' + el.getAttribute("data-rec-expand") + '"]');
        if (!opts) return;
        opts.classList.toggle("is-open");
        // 2026-07-10: a multi-variant rec's "add" button reveals a size/colour
        // picker (you can't add without a choice). If the picker opens below
        // the fold the tap looks like a no-op, so bring it into view + mark
        // the card so it's obvious a choice is needed.
        if (opts.classList.contains("is-open")) {
          el.setAttribute("data-rec-expanded", "1");
          try { opts.scrollIntoView({ behavior: "smooth", block: "nearest" }); } catch (err) {}
        } else {
          el.removeAttribute("data-rec-expanded");
        }
      };
    });
    // pick an option value
    root.querySelectorAll("[data-rec-opt]").forEach(function (el) {
      el.onclick = function (e) {
        e.preventDefault(); e.stopPropagation();
        if (el.disabled) return;
        var idx = el.getAttribute("data-rec-opt"), dim = el.getAttribute("data-dim");
        recSel[idx] = recSel[idx] || {}; recSel[idx][dim] = el.getAttribute("data-val");
        root.querySelectorAll('[data-rec-opt="' + idx + '"][data-dim="' + dim + '"]').forEach(function (c) { c.classList.toggle("is-sel", c === el); });
        updateConfirm(idx);
      };
    });
    // 2026-07-10: rebuild a minimal rec from the identity stamped on the
    // button when currentRecs has been reset under us (every cart
    // re-render / recs reload wipes it). Guarantees a tap NEVER silently
    // no-ops: worst case the customiser opens via the stamped identity,
    // or we fall back to navigating to the PDP.
    function recFromEl(el, idx) {
      var rec = currentRecs[+idx];
      if (rec && rec.productId) return rec;
      var pid = el.getAttribute("data-pid");
      var handle = el.getAttribute("data-handle");
      if (!pid || !handle) return null;
      return {
        handle: handle, productId: pid, title: el.getAttribute("data-title") || handle,
        url: el.getAttribute("data-url") || ("/products/" + handle),
        variants: (rec && rec.variants) || [], hasCustomiser: true,
      };
    }
    // single-variant customiser product -> open the in-cart customiser
    root.querySelectorAll("[data-rec-cz]").forEach(function (el) {
      el.onclick = function (e) {
        e.preventDefault(); e.stopPropagation();
        emit("rkc_rec_clicked", { handle: el.getAttribute("data-handle") || "", mode: "customise" });  // 2026-07-10
        var rec = recFromEl(el, el.getAttribute("data-rec-cz"));
        var url = el.getAttribute("data-url");
        if (!rec) { if (url) window.location.href = url; return; }
        var vid = el.getAttribute("data-vid");
        var v = (rec.variants || []).filter(function (x) { return String(x.id) === String(vid); })[0] || (rec.variants || [])[0]
          || (vid ? { id: vid, opts: [] } : null);
        openCustomiser(rec, v);
      };
    });
    // confirm the chosen variant -> add to cart OR open the customiser
    root.querySelectorAll("[data-rec-confirm]").forEach(function (el) {
      el.onclick = function (e) {
        e.preventDefault(); e.stopPropagation();
        if (el.disabled) return;
        emit("rkc_rec_clicked", { handle: el.getAttribute("data-handle") || "", mode: el.getAttribute("data-mode") || "" });  // 2026-07-10
        var idx = el.getAttribute("data-rec-confirm");
        var rec = recFromEl(el, idx);
        var url = el.getAttribute("data-url");
        if (!rec) { if (url) window.location.href = url; return; }
        var v = resolveVariant(currentRecs[+idx] || rec, recSel[idx] || {});
        if (!v || !v.available) {
          // Picks were wiped by a re-render mid-selection. Don't die
          // silently: the PDP can finish the job.
          if (url) window.location.href = url;
          return;
        }
        if (el.getAttribute("data-mode") === "customise") openCustomiser(rec, v);
        else quickAdd(v.id, el);
      };
    });
  }
  function quickAdd(vid, el) {
    if (!vid) return;
    el.disabled = true; el.classList.add("is-adding");
    // the fetch interceptor's onAdded() re-fetches + re-renders the drawer
    fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, credentials: "same-origin", body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 }) })
      .then(function (r) { if (!r.ok) throw 0; })
      .catch(function () { el.disabled = false; el.classList.remove("is-adding"); });
  }

  /* ---------- in-cart customiser (mounts the real customiser bundle) ---------- */
  var czBundle = null;
  function loadCustomiserBundle() {
    if (typeof window.__RK_PC_MOUNT__ === "function") return Promise.resolve(true);
    if (!czBundle) {
      czBundle = new Promise(function (resolve, reject) {
        var s = document.createElement("script");
        s.type = "module"; s.src = WORKER + "/static/customiser.js";
        s.onload = function () { resolve(true); };
        s.onerror = function () { reject(new Error("bundle")); };
        document.head.appendChild(s);
      });
    }
    return czBundle;
  }
  function closeCustomiser() {
    var m = document.getElementById("rkc-cz");
    if (m && m.parentNode) m.parentNode.removeChild(m);
  }
  function openCustomiser(rec, variant) {
    if (!rec || !WORKER || !rec.productId) { if (rec) window.location.href = rec.url; return; }
    closeCustomiser();
    var gid = "gid://shopify/Product/" + rec.productId;
    var modal = document.createElement("div");
    modal.id = "rkc-cz"; modal.className = "rkc-cz";
    modal.innerHTML =
      '<div class="rkc-cz__overlay" data-cz="close"></div>' +
      '<div class="rkc-cz__panel"><div class="rkc-cz__head">' +
        '<button class="rkc-cz__back" data-cz="close">' + ICO_ARROW_L + " bag</button>" +
        '<span class="rkc-cz__title">' + esc(rec.title) + "</span>" +
        '<button class="rkc-cz__x" data-cz="close" aria-label="close">' + ICO_X + "</button>" +
      '</div><div class="rkc-cz__host" id="rkc-cz-host"><div class="rkc-cz__loading">loading the customiser...</div></div></div>';
    root.appendChild(modal);
    lockScroll(true);
    modal.querySelectorAll('[data-cz="close"]').forEach(function (el) { el.onclick = function (e) { e.preventDefault(); closeCustomiser(); }; });

    var host = modal.querySelector("#rkc-cz-host");
    loadCustomiserBundle().then(function () {
      if (!window.__RK_PC_CONFIG__) window.__RK_PC_CONFIG__ = {};
      if (!window.__RK_PC_CONFIG__[gid]) {
        window.__RK_PC_CONFIG__[gid] = fetch(WORKER + "/api/config?productGid=" + encodeURIComponent(gid)).then(function (r) { return r.json(); });
        window.__RK_PC_CONFIG__[gid].catch(function () {});
      }
      if (typeof window.__RK_PC_MOUNT__ !== "function") { host.innerHTML = '<div class="rkc-cz__err">Couldn\'t load the customiser. <a href="' + esc(rec.url) + '">Open the product page.</a></div>'; return; }
      host.innerHTML = "";
      window.__RK_PC_MOUNT__(host, {
        workerUrl: WORKER, productGid: gid, productHandle: rec.handle,
        shopDomain: SHOP_DOMAIN, currency: CURRENCY, customerEmail: CUSTOMER_EMAIL,
        variantId: variant ? String(variant.id) : "",
        variantSize: variant ? (variant.opts || [])[0] || null : null,
        garmentColourName: variant ? (variant.opts || [])[1] || null : null,
        garmentColourHex: null,
        missingOption: (variant && variant.id) ? null : "size"
      });
    }).catch(function () {
      host.innerHTML = '<div class="rkc-cz__err">Couldn\'t load the customiser. <a href="' + esc(rec.url) + '">Open the product page.</a></div>';
    });
  }

  function footHTML(cart, sb) {
    // Name the total saving (multi-buy + free gift + any other automatic
    // discount) right above the subtotal so the deal is felt at checkout.
    var saved = cart.total_discount || 0;
    var savedHTML = saved > 0
      ? '<div class="rkc-foot__save">you’re saving ' + formatMoney(saved) + "</div>"
      : "";
    // 2026-07-10: reassurance row directly above checkout. sb is the ship-by
    // value ALREADY computed once in render() (reused, never recomputed);
    // null when RKShipBy is absent or nothing custom is in the bag, in which
    // case only the Melbourne line shows.
    var assure = '<div class="rkc-foot__assure">' +
      (sb && sb.label ? "<span>" + COPY.postBy + " <b>" + esc(sb.label) + "</b></span><span>&middot;</span>" : "") +
      "<span>" + COPY.assure + "</span></div>";
    return '<div class="rkc-foot">' +
      savedHTML +
      '<div class="rkc-foot__totals"><span class="rkc-foot__label">subtotal</span><span class="rkc-foot__amt">' + formatMoney(cart.total_price || 0) + "</span></div>" +
      assure +
      '<button class="rkc-checkout" data-act="checkout">' + ICO_LOCK + COPY.checkout + "</button>" +
      '<div class="rkc-foot__sub"><span>' + COPY.madeIn + "</span><span>&middot;</span><span>" + COPY.turnaround + "</span></div></div>";
  }

  function emptyHTML() {
    // Empty state is a storefront, not a dead end: primary CTA goes to the
    // customiser collection, and the curated products (already in config)
    // give three tappable ways back into shopping.
    return '<div class="rkc-body"><div class="rkc-empty">' +
      '<div class="rkc-empty__ic"><svg width="56" height="56" viewBox="0 0 100 100"><rect x="31" y="22" width="38" height="56" rx="5" fill="#fff" stroke="#5C1756" stroke-width="3"/><path d="M37 42 H63 M37 52 H63 M37 62 H63" stroke="#F38BB9" stroke-width="3" stroke-linecap="round"/></svg></div>' +
      '<div class="rkc-empty__h">' + COPY.emptyTitle + "</div>" +
      '<div class="rkc-empty__p">' + COPY.emptySub + "</div>" +
      '<a class="rkc-empty__cta" href="/collections/rk-custom-multi-buy">' + COPY.emptyCta + "</a></div>" +
      curatedHTML() +
      "</div>";
  }

  // 2026-07-10: analytics - first time this session the qualifying spend
  // crosses the gift threshold. sessionStorage-gated so re-renders/reloads
  // don't re-fire; storage-less browsers just skip the event.
  function maybeGiftUnlocked(cart) {
    if (!GIFT_ON || !cart) return;
    try {
      if (qualifyingSubtotal(cart) < GIFT.threshold) return;
      if (sessionStorage.getItem("rkc_gift_evt")) return;
      sessionStorage.setItem("rkc_gift_evt", "1");
      emit("rkc_gift_unlocked");
    } catch (e) {}
  }

  function render() {
    var cart = state.cart;
    var dcount = displayCount(cart);
    var head = '<div class="rkc-head"><div class="rkc-head__title"><h2>your bag</h2>' +
      '<span class="rkc-head__count">' + dcount + " item" + (dcount === 1 ? "" : "s") + "</span></div>" +
      '<button class="rkc-close" data-act="close" aria-label="close">' + ICO_X + "</button></div>";

    var inner;
    if (!cart || cart.item_count === 0) {
      inner = head + emptyHTML() +
        '<div class="rkc-foot"><div class="rkc-foot__sub"><span>' + COPY.madeIn + "</span><span>&middot;</span><span>" + COPY.turnaround + "</span></div></div>";
    } else {
      maybeGiftUnlocked(cart);
      // drop a stranded $150 express fee before drawing anything
      if (fdrReconcile(cart)) return;
      var rowList = buildRows(cart);
      var rows = rowList.map(rowHTML).join("");
      var giftRow = GIFT_ON ? (giftRowHTML(giftLineOf(cart)) || lockedGiftHTML(cart)) : "";
      // Mixed-rush warning (ported natively 2026-07-02; the old
      // rush-mix-warning.liquid targeted the removed Rebuy DOM). Rush is
      // per-item but the order ships as ONE parcel at the slowest item's
      // pace - warn when only some custom items are rushed.
      var customRows = rowList.filter(function (r) { return r.custom; });
      function isRowRushed(r) {
        var p = (r.primary && r.primary.properties) || {};
        for (var k in p) {
          if (!p.hasOwnProperty(k)) continue;
          if (/rush/i.test(k) || /rush/i.test(String(p[k] || ""))) return true;
        }
        return (r.addons || []).some(function (a) { return a && a.kind === "rush"; });
      }
      var rushedCount = customRows.filter(isRowRushed).length;
      var rushMix = "";
      if (customRows.length > 1 && rushedCount > 0 && rushedCount < customRows.length) {
        rushMix = '<div class="rkc-rushmix">' + COPY.rushMix + "</div>";
      }
      // Made-to-order "we'll post it by <date>" estimate. The whole order ships
      // together at the slowest piece's pace, so it's only the faster rush date
      // when EVERY custom piece is rushed. Skipped when nothing custom is in
      // the bag (nothing to make). 2026-07-10: sb hoisted so footHTML's
      // reassurance row reuses the SAME computed value; compute() wrapped so
      // a shipby failure can never blank the whole drawer.
      // Father's Day express overrides the made-to-order promise entirely:
      // showing "we'll post it by <10 days>" next to a $150 next-business-day
      // upgrade is a straight contradiction. The same line also replaces the
      // mixed-rush warning, which is about PER-ITEM rush and would tell the
      // customer their express only covers one item.
      var fdrOn = !!fdrLineOf(cart);
      var shipByHTML = "", sb = null;
      if (fdrOn) {
        rushMix = "";
        shipByHTML = '<div class="rkc-shipby rkc-shipby--express"><span class="rkc-shipby__ico" aria-hidden="true">⚡</span> ' +
          'Made first and posted <b>EXPRESS next business day</b>' +
          '<span class="rkc-shipby__rush">express</span></div>';
      }
      if (!fdrOn && window.RKShipBy && customRows.length > 0) {
        var allRushed = rushedCount === customRows.length;
        try { sb = window.RKShipBy.compute(allRushed ? "rush" : "standard"); } catch (e) {}
        if (sb) {
          shipByHTML = '<div class="rkc-shipby"><span class="rkc-shipby__ico" aria-hidden="true">🧵</span> ' + COPY.shipBy + " <b>" + sb.label + "</b>" +
            (allRushed ? ' <span class="rkc-shipby__rush">rush</span>' : "") + "</div>";
          stampShipBy(cart, sb, allRushed);
        }
      }
      inner = head + rewardHTML(cart) +
        '<div class="rkc-body"><div class="rkc-items">' + rows + giftRow + '</div><div id="rkc-cross-slot">' + lastRecsHtml + "</div></div>" +
        rushMix + shipByHTML + fdrHTML(cart) + footHTML(cart, sb);
    }
    root.innerHTML = '<div class="rkc-overlay" data-act="overlay"></div><div class="rkc-drawer" role="dialog" aria-modal="true" aria-label="Your bag">' + inner + "</div>";
    bind();
    if (cart && cart.item_count > 0) loadRecommendations(cart);
  }

  // Write the ship-by promise onto the cart as the "Ships by" attribute so it
  // lands on the order.
  //
  // 2026-07-22: this used to be the job of the checkout UI extension at
  // extensions/checkout-ship-by in rk-custom-builder. That extension targets
  // purchase.checkout.cart-line-list.render-after, and every purchase.checkout.*
  // target is Shopify Plus only. This store is on the plain Shopify plan, so the
  // extension never mounts, its useEffect never runs, and applyAttributeChange
  // never fires. Verified: not one of the 30 most recent orders carries ANY
  // custom attribute. Doing it here means the date the customer was shown in the
  // drawer is the date recorded against the order.
  //
  // Writes only on change. lastShipByWritten stops the render -> write ->
  // cart-changed -> render loop, and is cleared on failure so a transient error
  // still retries on the next render.
  var lastShipByWritten = null;
  function stampShipBy(cart, sb, allRushed) {
    if (!sb || !sb.label) return;
    var want = sb.label + (allRushed ? " (rush)" : "");
    var have = (cart && cart.attributes && cart.attributes["Ships by"]) || null;
    if (have === want || lastShipByWritten === want) return;
    lastShipByWritten = want;
    _fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ attributes: { "Ships by": want } }),
    }).catch(function () { lastShipByWritten = null; });
  }

  /* ---------- mutations ---------- */
  function updateLines(map) {
    state.busy = true; state.suppress = true;
    return fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ updates: map })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { state.cart = cart; return reconcileGift(cart); })  // update.js returns the full cart -> reconcile it directly, no extra GET
      .then(function () { render(); syncTheme(); })
      .catch(function () { fetchCart().then(render); })
      .then(function () { state.busy = false; setTimeout(function () { state.suppress = false; }, 120); });
  }
  function setGroupQty(keys, qty) {
    var map = {};
    keys.forEach(function (k) { map[k] = qty; });
    return updateLines(map);
  }

  /* ---------- free gift reconcile (drawer UX; checkout is the real gate) ---------- */
  // uses the UN-patched _fetch so the add-to-cart interceptor (onAdded) never fires
  // on our own gift add -> no auto-open loop. update.js/change.js aren't intercepted.
  function rawUpdate(map) {
    return _fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, credentials: "same-origin", body: JSON.stringify({ updates: map }) })
      .then(function (r) { return r.json(); })
      .then(function (c) { state.cart = c; return c; });
  }
  function giftDefaultVariant() {
    var pref = null; try { pref = localStorage.getItem("rkc_gift_colour"); } catch (e) {}
    if (pref) { for (var i = 0; i < GIFT.variants.length; i++) if (GIFT.variants[i].colour === pref) return GIFT.variants[i]; }
    return GIFT.variants[0];
  }
  function giftAdd(variantId) {
    return _fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, credentials: "same-origin", body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1, properties: { _rk_free_gift: "1" } }) })
      .then(function (r) { if (!r.ok) throw 0; })
      .then(fetchCart);
  }
  // keep the cart's gift line consistent with the spend. Always resolves to a cart.
  function reconcileGift(cart) {
    if (!GIFT_ON || state.giftLock) return Promise.resolve(cart);
    var giftLines = ((cart && cart.items) || []).filter(isGiftLine);
    var qual = qualifyingSubtotal(cart);
    var settle = function (p) { return p.then(function (nc) { state.giftLock = false; return nc || cart; }, function () { state.giftLock = false; return cart; }); };
    if (qual < GIFT.threshold) {                          // under threshold -> no gift
      if (!giftLines.length) return Promise.resolve(cart);
      state.giftLock = true;
      var rm = {}; giftLines.forEach(function (g) { rm[g.key] = 0; });
      return settle(rawUpdate(rm));
    }
    // Gift line left over from a PREVIOUS gift product (see isStaleGiftLine).
    // Drop it and re-add the current gift in the same pass, so the customer
    // never sees the row vanish and the cart never checks out the old product
    // under the new product's name.
    var staleLines = giftLines.filter(isStaleGiftLine);
    if (staleLines.length) {
      state.giftLock = true;
      var rmStale = {}; staleLines.forEach(function (g) { rmStale[g.key] = 0; });
      return settle(rawUpdate(rmStale).then(function () {
        return fetchCart().then(function (fresh) {
          return giftLineOf(fresh) ? fresh : giftAdd(giftDefaultVariant().variantId);
        });
      }));
    }
    if (!giftLines.length) {                              // at/over threshold, no gift yet -> add
      state.giftLock = true;
      // re-read live before adding: if a concurrent reconcile (acting on a stale
      // snapshot) already added the gift, don't add a second one.
      return settle(fetchCart().then(function (fresh) {
        return giftLineOf(fresh) ? fresh : giftAdd(giftDefaultVariant().variantId);
      }));
    }
    if (giftLines.length > 1 || giftLines[0].quantity !== 1) {  // keep exactly one, qty 1
      state.giftLock = true;
      var mp = {}; giftLines.forEach(function (g, i) { mp[g.key] = (i === 0 ? 1 : 0); });
      return settle(rawUpdate(mp));
    }
    return Promise.resolve(cart);
  }
  // fresh read + gift reconcile. NOT coalesced: callers (add-on adds, onAdded)
  // need the POST-mutation cart, so each gets its own fresh /cart.js read.
  // Double-add is prevented by state.giftLock (serialises reconcile) + the add
  // branch's re-read guard above.
  function refreshCart() { return fetchCart().then(reconcileGift); }
  // colour swap on the gift row: ADD the chosen colour first, THEN drop the old
  // line, so a failed add never leaves the cart with zero gift.
  function giftSwapColour(newVid, currentKey, colour, el) {
    if (state.giftLock) return;
    state.giftLock = true; state.suppress = true;
    if (el) { var box = el.closest(".rkc-gift__chips"); if (box) box.classList.add("is-busy"); }
    try { localStorage.setItem("rkc_gift_colour", colour); } catch (e) {}
    giftAdd(newVid)
      .then(function () { var rm = {}; rm[currentKey] = 0; return rawUpdate(rm); })
      .then(function () {
        state.giftLock = false; render(); syncTheme();
        setTimeout(function () { state.suppress = false; }, 120);
      })
      .catch(function () {
        // add failed (e.g. colour sold out): old gift is untouched. Recover + clamp.
        state.giftLock = false; setTimeout(function () { state.suppress = false; }, 120);
        fetchCart().then(function (c) { return reconcileGift(c); }).then(render);
      });
  }

  /* ---------- theme sync (cart count + events) ---------- */
  function syncTheme() {
    var cart = state.cart;
    try {
      if (window.Alpine && Alpine.store && Alpine.store("cart_count")) {
        Alpine.store("cart_count").count = displayCount(cart);
      }
    } catch (e) {}
    ["cart:updated", "cart:refresh", "cart-updated"].forEach(function (name) {
      try { document.dispatchEvent(new CustomEvent(name, { detail: { cart: cart } })); } catch (e) {}
    });
  }

  /* ---------- open / close ---------- */
  function lockScroll(lock) {
    document.documentElement.style.overflow = lock ? "hidden" : "";
    document.body.style.overflow = lock ? "hidden" : "";
  }
  var lastFocusEl = null;
  function open() {
    var wasOpen = root.classList.contains("is-open");   // 2026-07-10: onAdded re-opens while open; only count real opens
    var run = state.cart ? Promise.resolve() : refreshCart().then(render);
    run.then(function () {
      resetCheckoutBtn();   // a prior checkout click may have left it disabled + "taking you..."
      root.classList.add("is-open");
      lockScroll(true);
      // a11y: the drawer asserts role=dialog aria-modal, so actually move
      // focus into it (close button) and remember where to return it.
      lastFocusEl = document.activeElement;
      var c = root.querySelector(".rkc-close");
      if (c) { try { c.focus(); } catch (e) {} }
      if (!wasOpen) {
        var ct = state.cart || {}, its = ct.items || [], hasCustom = false;
        for (var i = 0; i < its.length; i++) { var pp = its[i].properties; if (pp && pp._rk_group_id) { hasCustom = true; break; } }
        emit("rkc_cart_opened", { item_count: ct.item_count || 0, cart_value: (ct.total_price || 0) / 100, has_custom: hasCustom });
      }
    });
  }
  // the checkout button is disabled + relabelled on click (before navigating). If the
  // customer comes back (browser back / bounced nav), un-stick it.
  function resetCheckoutBtn() {
    var co = root.querySelector(".rkc-checkout");
    if (co && co.disabled) { co.disabled = false; co.innerHTML = ICO_LOCK + COPY.checkout; }
  }
  function close() {
    root.classList.remove("is-open");
    lockScroll(false);
    // a11y: return focus to whatever opened the drawer.
    if (lastFocusEl && typeof lastFocusEl.focus === "function") {
      try { lastFocusEl.focus(); } catch (e) {}
    }
    lastFocusEl = null;
  }

  // a11y: loop Tab within the open drawer so keyboard users can't wander
  // into the obscured page behind the overlay.
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Tab" || !root.classList.contains("is-open")) return;
    var f = root.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select, [tabindex]:not([tabindex="-1"])'
    );
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- events ---------- */
  function bind() {
    root.querySelectorAll("[data-act]").forEach(function (el) {
      el.onclick = function (e) {
        var act = el.getAttribute("data-act");
        if (act === "overlay" || act === "close") { e.preventDefault(); close(); return; }
        if (act === "checkout") {
          e.preventDefault();
          // 2026-07-10: fired synchronously BEFORE the redirect (the
          // dataLayer push is sync; gtag may not beacon in time - accepted).
          var cc = state.cart || {};
          emit("rkc_checkout_clicked", { item_count: cc.item_count || 0, cart_value: (cc.total_price || 0) / 100 });
          el.disabled = true; el.textContent = COPY.checkoutBusy;
          // paused day (drawer left open past midnight, or the line added in
          // another tab): check the REAL cart, take super urgent out and redraw
          // so the paused note says why, instead of selling it
          if (fdrPause()) {
            fetchCart().then(function (c) {
              var fl = fdrLineOf(c);
              if (!fl) { window.location.href = CHECKOUT_URL; return; }
              return _fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, credentials: "same-origin", body: JSON.stringify({ id: fl.key, quantity: 0 }) })
                .then(function () { return refreshCart(); })
                .then(function () { render(); syncTheme(); });
            }).catch(function () { el.disabled = false; el.innerHTML = ICO_LOCK + COPY.checkout; fetchCart().then(render); });
            return;
          }
          window.location.href = CHECKOUT_URL;
          return;
        }
        if (act === "gift-colour") {
          e.preventDefault();
          if (el.classList.contains("is-sel")) return;
          giftSwapColour(el.getAttribute("data-gift-vid"), el.getAttribute("data-gift-key"), el.getAttribute("data-colour"), el);
          return;
        }
        // Father's Day express is ORDER-level: its buttons live outside any
        // row, so they must be handled BEFORE the row guard below.
        if (act === "fdr-add") {
          e.preventDefault();
          el.disabled = true; el.classList.add("is-adding");
          addFdr();
          return;
        }
        if (act === "fdr-off") {
          e.preventDefault();
          var fk = el.getAttribute("data-key");
          if (fk) { el.disabled = true; el.classList.add("is-adding"); setGroupQty([fk], 0); }
          return;
        }
        var rowEl = el.closest("[data-row]");
        if (!rowEl) return;
        var keys = rowEl.getAttribute("data-row").split("|");
        var current = parseInt(rowEl.querySelector(".rkc-stepper span").textContent, 10) || 1;
        if (act === "inc") { e.preventDefault(); rowEl.classList.add("is-busy"); emit("rkc_qty_changed", { new_qty: current + 1 }); setGroupQty(keys, current + 1); }
        else if (act === "dec") { e.preventDefault(); rowEl.classList.add("is-busy"); var nq = Math.max(0, current - 1); emit("rkc_qty_changed", { new_qty: nq }); setGroupQty(keys, nq); }
        else if (act === "remove") { e.preventDefault(); rowEl.classList.add("is-busy"); emit("rkc_line_removed"); setGroupQty(keys, 0); }
        else if (act === "edit-design") {
          // 2026-07-10: reopen the in-cart customiser for a folded custom row.
          // The rec is built straight from the cart line (no fetch needed:
          // /cart.js lines carry product_id/handle/url/title + option values);
          // the customiser's "Reuse a design in your cart" tile restores the
          // saved design. openCustomiser itself falls back to the PDP when the
          // worker/bundle is unavailable, and the builder auto-restores its
          // session there.
          e.preventDefault();
          var pk = rowEl.getAttribute("data-primary"), item = null;
          ((state.cart && state.cart.items) || []).forEach(function (it) { if (it.key === pk) item = it; });
          if (!item) return;
          if (!item.product_id) { if (item.url) window.location.href = item.url; return; }
          var zrec = { handle: item.handle, productId: item.product_id, title: item.product_title || item.title, url: item.url || ("/products/" + item.handle), variants: [], hasCustomiser: true };
          openCustomiser(zrec, { id: item.variant_id, opts: (item.options_with_values || []).map(function (o) { return o.value; }) });
        }
        else if (act === "addon") {
          e.preventDefault();
          var addon = addonMeta(el.getAttribute("data-addon"));
          if (!addon || !addon.variantId) return;
          emit("rkc_addon_added", { kind: addon.kind });
          el.disabled = true; el.classList.add("is-adding");
          addAddon(addon, rowEl.getAttribute("data-primary"), parseInt(rowEl.getAttribute("data-qty"), 10) || 1);
        }
        else if (act === "addon-remove") {
          e.preventDefault();
          var ak = el.getAttribute("data-key");
          if (ak) { el.disabled = true; el.classList.add("is-adding"); setGroupQty([ak], 0); }
        }
      };
    });
  }
  // add a per-item add-on (gift box / rush) as a line linked to the target item.
  // OPTIMISTIC: flip the chip to "on" immediately (this store's cart round-trips
  // run ~1-2s, and the silent wait reads as "it didn't stick"), then confirm with
  // the real add via the UNPATCHED _fetch (drawer already open -> skip onAdded's
  // Father's Day express section. Rendered between the ship-by promise and
  // the footer, because it is a delivery-speed choice. Optimistic like
  // addAddon: flip immediately, confirm with the real cart call.
  function fdrHTML(cart) {
    // paused day: say when it is back instead of offering it (a line already
    // in the cart is being taken out by fdrReconcile)
    var pause = fdrPause();
    if (pause) {
      if (!FDR.pauseNote || !fdrHasRushableItems(cart)) return "";
      var note = String(FDR.pauseNote).replace(/\{today\}/g, pause.today).replace(/\{day\}/g, pause.back);
      return '<div class="rkc-fdr is-paused"><div class="rkc-fdr__txt"><b>' + esc(FDR.title) + "</b><span>" + esc(note) + "</span></div></div>";
    }
    if (!fdrOffered() && !fdrLineOf(cart)) return "";
    var line = fdrLineOf(cart);
    if (!line && !fdrHasRushableItems(cart)) return "";
    if (line) {
      return '<div class="rkc-fdr is-on">' +
        '<div class="rkc-fdr__on">' +
          '<span class="rkc-fdr__tick" aria-hidden="true">✓</span>' +
          '<div class="rkc-fdr__txt"><b>' + esc(FDR.onLabel || "Express added") + "</b>" +
            '<span>Made first and posted EXPRESS next business day.</span></div>' +
          '<span class="rkc-fdr__amt">' + formatMoney(FDR.price) + "</span>" +
          '<button type="button" class="rkc-fdr__off" data-act="fdr-off" data-key="' + esc(line.key) + '" aria-label="Remove Father&#39;s Day express">remove</button>' +
        "</div></div>";
    }
    return '<div class="rkc-fdr">' +
      '<div class="rkc-fdr__txt"><b>' + esc(FDR.title) + "</b><span>" + esc(FDR.blurb) + "</span></div>" +
      '<button type="button" class="rkc-fdr__add" data-act="fdr-add">' + esc(FDR.cta) + "</button>" +
      "</div>";
  }
  function addFdr() {
    if (!FDR || !FDR.variantId) return;
    // drawer drawn before midnight, button tapped after: redraw with the note
    if (fdrPause()) { render(); return; }
    var props = { _rk_cart_addon: FDR_KIND, _rk_super_rush: "yes" };
    props["Father's Day express"] = "Posted express next business day";
    var cents = FDR.price || 0;
    if (state.cart && state.cart.items) {
      state.cart.items.push({
        id: FDR.variantId, variant_id: FDR.variantId, quantity: 1, key: "__fdr_pending",
        line_price: cents, final_line_price: cents, original_line_price: cents,
        properties: props, _optimistic: true
      });
      state.cart.item_count = (state.cart.item_count || 0) + 1;
      render();
    }
    emit("rkc_addon_added", { kind: FDR_KIND });
    state.suppress = true;
    _fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, credentials: "same-origin", body: JSON.stringify({ id: parseInt(FDR.variantId, 10), quantity: 1, properties: props }) })
      .then(function (r) { if (!r.ok) throw 0; })
      .then(refreshCart)
      .then(function () { render(); syncTheme(); setTimeout(function () { state.suppress = false; }, 120); })
      .catch(function () { state.suppress = false; fetchCart().then(render); });
  }
  // Never leave a $150 fee sitting on a cart with nothing to rush (customer
  // removed the garments but kept the fee). Cheap check on every render.
  var fdrTried = {};
  function fdrReconcile(cart) {
    var line = fdrLineOf(cart);
    if (!line) return false;
    var stale = !fdrHasRushableItems(cart) || (!fdrOffered() && !FDR_KEEP_STALE);
    if (!stale || line._optimistic) return false;
    // one attempt per line per page view: a failing update.js must not loop
    // remove -> refetch -> render -> remove (the checkout click retries)
    if (fdrTried[line.key]) return false;
    fdrTried[line.key] = true;
    setGroupQty([line.key], 0).then(function () {
      // the full /cart page is server-rendered and its form posts updates[]
      // by position: reload it so it matches the cart we just changed
      if (!fdrLineOf(state.cart) && fdrCartPageForm()) location.reload();
    });
    return true;
  }
  function fdrCartPageForm() {
    return document.querySelector('form#cart[action*="/cart"]');
  }
  // /cart page checkout on a paused day: take a super urgent line out first
  // and reload, so it is never bought from the plain cart page either.
  var fdrCartSubmitOk = false;
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (fdrCartSubmitOk || !form || form.id !== "cart" || !fdrPause()) return;
    var submitter = e.submitter || null;
    e.preventDefault();
    fetchCart().then(function (c) {
      var line = fdrLineOf(c);
      if (line) {
        return _fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, credentials: "same-origin", body: JSON.stringify({ id: line.key, quantity: 0 }) })
          .then(function () { location.reload(); });
      }
      fdrCartSubmitOk = true;
      if (form.requestSubmit) form.requestSubmit(submitter && submitter.form === form ? submitter : undefined);
      else {
        if (submitter && submitter.name) { var h = document.createElement("input"); h.type = "hidden"; h.name = submitter.name; h.value = submitter.value || ""; form.appendChild(h); }
        form.submit();
      }
    }).catch(function () { fdrCartSubmitOk = true; form.submit(); });
  }, true);
  // Set true only to debug an expired window without the line vanishing.
  var FDR_KEEP_STALE = false;

  // auto-open + 250ms debounce). If the add fails, the refresh reverts it.
  function addAddon(addon, targetKey, qty) {
    qty = qty || 1;
    var props = { _rk_addon_for: targetKey, _rk_cart_addon: addon.kind };
    props["Add-on: " + addon.label] = addon.price;
    var cents = Math.round((parseFloat(String(addon.price).replace(/[^0-9.]/g, "")) || 0) * 100) * qty;
    if (state.cart && state.cart.items) {
      state.cart.items.push({
        id: addon.variantId, variant_id: addon.variantId, quantity: qty,
        key: "__opt_" + addon.kind + "_" + targetKey,
        line_price: cents, final_line_price: cents, original_line_price: cents,
        properties: props, _optimistic: true
      });
      state.cart.item_count = (state.cart.item_count || 0) + qty;
      render();   // instant feedback
    }
    state.suppress = true;
    _fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, credentials: "same-origin", body: JSON.stringify({ id: parseInt(addon.variantId, 10), quantity: qty, properties: props }) })
      .then(function (r) { if (!r.ok) throw 0; })
      .then(refreshCart)
      .then(function () { render(); syncTheme(); setTimeout(function () { state.suppress = false; }, 120); })
      .catch(function () { state.suppress = false; fetchCart().then(render); });
  }

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && root.classList.contains("is-open")) close();
  });

  // Back/forward-cache restore (e.g. customer clicks checkout, then hits browser
  // Back): the page is served from bfcache with the drawer DOM frozen mid-nav -
  // checkout button stuck on "taking you to checkout...", add-on/gift state stale.
  // Re-sync from the live cart so the button unsticks and the drawer is accurate.
  window.addEventListener("pageshow", function (e) {
    if (e && e.persisted) {
      resetCheckoutBtn();
      refreshCart().then(render).catch(function () { render(); });
    }
  });

  /* ---------- add-to-cart interception (auto-open) ---------- */
  var addDebounce = null;
  function onAdded() {
    if (addDebounce) clearTimeout(addDebounce);
    addDebounce = setTimeout(function () {
      // a gift add/swap is mid-flight: retry after it settles rather than render
      // a half-updated snapshot (avoids a gift-less flash under an "unlocked" bar).
      if (state.giftLock) { onAdded(); return; }
      closeCustomiser();
      state.suppress = true;   // our syncTheme dispatch below must not re-enter the self-listener
      refreshCart().then(function () {
        render(); syncTheme(); open();
        setTimeout(function () { state.suppress = false; }, 120);
      });
    }, 250);
  }
  function isAddUrl(url) {
    if (!url) return false;
    url = String(url);
    return /\/cart\/add(\.js)?(\?|$)/.test(url);
  }
  // fetch
  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function (input, init) {
      var url = (typeof input === "string") ? input : (input && input.url);
      var method = (init && init.method) || (input && input.method) || "GET";
      var p = _fetch.apply(this, arguments);
      if (isAddUrl(url) && String(method).toUpperCase() === "POST") {
        p.then(function (res) { if (res && res.ok) onAdded(); }).catch(function () {});
      }
      return p;
    };
  }
  // XHR
  var _open = XMLHttpRequest.prototype.open;
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__rkc_add = isAddUrl(url) && String(method).toUpperCase() === "POST";
    return _open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this.__rkc_add) {
      this.addEventListener("load", function () {
        if (this.status >= 200 && this.status < 300) onAdded();
      });
    }
    return _send.apply(this, arguments);
  };
  // other code changing the cart -> keep in sync (do not auto-open)
  ["cart:refresh", "cart:updated", "cart-updated", "rebuy:cart:refresh"].forEach(function (name) {
    document.addEventListener(name, function () {
      if (state.suppress) return;
      refreshCart().then(render);
    });
  });

  /* ---------- boot ---------- */
  recordRecentlyViewed();
  window.RKCart = { open: open, close: close, refresh: function () { return refreshCart().then(render); } };
  refreshCart().then(render).catch(function () { render(); });
})();
